import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { adminAuthAPI } from '../../services/adminAPI';
import '../admin/admin.css';

const AdminForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await adminAuthAPI.forgotPassword({ email });
      setEmailSent(true);
    } catch (err) {
      console.error('Admin forgot password error:', err);
      setError(err.response?.data?.error || 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  if (emailSent) {
    return (
      <div className="admin-login-container">
        <div className="admin-login-card" style={{ textAlign: 'center' }}>
          <div className="admin-login-header">
            <div style={{ fontSize: '64px', marginBottom: '20px' }}>📧</div>
            <h1>Check Your Email</h1>
            <p>Password reset instructions have been sent</p>
          </div>

          <div style={{ marginBottom: '30px', color: '#999', lineHeight: '1.6' }}>
            <p>
              If an admin account exists with <strong style={{ color: '#4CAF50' }}>{email}</strong>, 
              you will receive password reset instructions shortly.
            </p>
            <p style={{ fontSize: '0.9rem', marginTop: '15px' }}>
              Didn't receive the email? Check your spam folder.
            </p>
          </div>

          <Link 
            to="/admin/login"
            className="admin-btn"
            style={{ 
              display: 'inline-block',
              textDecoration: 'none',
              width: 'auto',
              padding: '12px 30px'
            }}
          >
            Back to Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <FontAwesomeIcon icon={faShieldAlt} />
          <h1>Admin Password Reset</h1>
          <p>Enter your admin email to receive reset instructions</p>
        </div>

        {error && (
          <div className="admin-error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="admin-form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              placeholder="admin@example.com"
            />
          </div>

          <button type="submit" className="admin-btn" disabled={loading}>
            {loading ? (
              <>
                <FontAwesomeIcon icon={faSpinner} spin />
                Sending...
              </>
            ) : (
              'Send Reset Link'
            )}
          </button>
        </form>

        <div style={{ 
          textAlign: 'center',
          marginTop: '20px',
          paddingTop: '20px',
          borderTop: '1px solid #2a2a2a'
        }}>
          <Link 
            to="/admin/login" 
            style={{ 
              color: '#4CAF50', 
              textDecoration: 'none',
              fontWeight: '600'
            }}
          >
            ← Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminForgotPassword;
